var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoEnterBlueLatest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 20,
    viewBox: "0 0 81 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_422_7227)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0V5H0V0H16ZM10.72 8L16 20H10.665L8 13L5.335 20H0L5.28 8H10.72Z",
    fill: "#2E6BE6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_422_7227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 4V16H33.5998V13.2853H27.2066V11.2107H33.0105V8.57422H27.2066V6.69517H33.5998V4H24Z",
    fill: "#2E3C50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1994 4H42.2913V10.1258L38.1698 4H35.5996V16H38.5077V9.46365L43.0197 16H45.1994V4Z",
    fill: "#2E3C50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1992 6.69517H50.4168V16H53.5622V6.69517H56.799V4H47.1992V6.69517Z",
    fill: "#2E3C50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 4V16H68.5998V13.2853H62.2066V11.2107H68.0105V8.57422H62.2066V6.69517H68.5998V4H59Z",
    fill: "#2E3C50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4166 12.0318L76.9208 16H80.3987L77.585 11.6998C79.0505 11.153 80.0886 9.90318 80.0886 8.0843C80.0886 5.46488 78.1908 4 75.6099 4H70.7988V16H73.9052V12.0318H74.4166ZM73.9052 6.63653H75.3973C76.5127 6.63653 77.0213 7.20403 77.0213 8.0843C77.0213 8.96457 76.5127 9.53207 75.3973 9.53207H73.9052V6.63653Z",
    fill: "#2E3C50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_422_7227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_422_7227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 12,
    fill: "white",
    transform: "translate(24 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEnterBlueLatest);
export default __webpack_public_path__ + "static/media/logo_enter_blue_latest.c81961cfe8dab85d26bf5adef7b6ad2f.svg";
export { ForwardRef as ReactComponent };